import React from 'react';
import {
  Image,
  Text,
  View,
} from 'react-native';
import { img_android_back, img_ios_back } from '../../../../utils/ImagesManagementUtils';
import {
  Android,
  Bank_520_4073_10,
  current_account_str,
  Date_09_08_2020, Dollar_100,
} from '../../../../utils/DictionaryManagementUtils';
import { getMediumFont, getRegularFont, LocStr } from '../../../../utils/Utils';

//= ========================================================================

const PhoneHeadLineWithBackgroundColor = ({
  globJSON, simPlatform, language, withTwoPoints,
}) => {
  const { colors } = globJSON.configurations.theme;
  const withTwoPointAndroid = withTwoPoints ? '35%' : '38%';
  const withTwoPointIos = withTwoPoints ? '40%' : '38%';
  const myStyles = {
    container: {
      height: simPlatform === Android ? withTwoPointAndroid : withTwoPointIos,
      backgroundColor: colors.primary_cta_color,
    },
    TopLine: {
      width: 23,
      height: 3,
      marginLeft: 108,
      marginTop: 3,
      borderRadius: 1.5,
      backgroundColor: colors.cta_font_color,
    },
    rowStyle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingHorizontal: 7,
    },
    iconStyle: {
      width: 14,
      height: 14,
      tintColor: colors.cta_font_color,
    },
    titleTxtStyle: {
      width: '100%',
      paddingTop: 6,
      paddingBottom: 4,
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 12.2,
      color: colors.cta_font_color,
      textAlign: 'center',
    },
    subTitleStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 8.1,
      color: colors.cta_font_color,
      textAlign: 'center',
    },
    priceTxtStyle: {
      paddingVertical: 2,
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 16,
      color: colors.cta_font_color,
      textAlign: 'center',
    },
    dateStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 8.1,
      color: colors.cta_font_color,
      textAlign: 'center',
    },
    TwoPointsStyle: {
      flexDirection: 'row',
      alignSelf: 'center',
    },
    firstPointStyle: {
      width: 5,
      height: 5,
      marginRight: 3,
      marginTop: 6,
      borderRadius: 2.5,
      backgroundColor: colors.cta_font_color,
    },
    SecondPointStyle: {
      width: 5,
      height: 5,
      marginLeft: 3,
      marginTop: 6,
      borderRadius: 2.5,
      backgroundColor: colors.cta_font_color,
      opacity: 0.75,
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.TopLine} />
      <View style={myStyles.rowStyle}>
        <Image
          fadeDuration={0}
          style={myStyles.iconStyle}
          source={simPlatform === Android ? img_android_back : img_ios_back}
        />
        <Text style={myStyles.titleTxtStyle}>{LocStr(current_account_str, language)}</Text>
      </View>
      <Text style={myStyles.subTitleStyle}>{Bank_520_4073_10}</Text>
      <Text style={myStyles.priceTxtStyle}>{Dollar_100}</Text>
      <Text style={myStyles.dateStyle}>{Date_09_08_2020}</Text>
      {withTwoPoints
          && (
          <View style={myStyles.TwoPointsStyle}>
            <View
              style={myStyles.firstPointStyle}
            />
            <View
              style={myStyles.SecondPointStyle}
            />
          </View>
          )}
    </View>
  );
};
export default PhoneHeadLineWithBackgroundColor;
